angular.module("ResearchKitApplicationModule", ['CareEvWidgets', 'ngSanitize', 'pascalprecht.translate']);